import { render, staticRenderFns } from "./HistoryProductRow.vue?vue&type=template&id=5c60a1fb&"
import script from "./HistoryProductRow.vue?vue&type=script&lang=js&"
export * from "./HistoryProductRow.vue?vue&type=script&lang=js&"
import style0 from "./HistoryProductRow.vue?vue&type=style&index=0&id=5c60a1fb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports